import Routes from '@domain/router/routes.constants';
import { createMiddleware } from '@shared/redux/create-middleware';
import { createMatchSelector, LOCATION_CHANGE, push } from 'connected-react-router';
import { showErrorToast } from '@shared/toasts/toasts.state';
import { openCardModal } from '../interface/card-interface.state';
import {
    getCard,
    GET_CARD_REQUEST_SUCCEEDED,
    GET_CARD_REQUEST_FAILED,
    getCardOriginRouter,
    EDIT_CARD_REQUEST_FAILED,
} from './card-selected.state';
import { isCardFromExternalLink } from './card-selected.utils';

export const cardSelectedMiddleware = createMiddleware({
    [LOCATION_CHANGE]: (state) => {
        const matchSelector = createMatchSelector(Routes.WORKFLOW_WITH_CARD_ID);
        const match = matchSelector(state);
        const originRoute = getCardOriginRouter(state);

        if (!isCardFromExternalLink(originRoute)) {
            return [];
        }

        if (!match) return [];

        const { params } = match;
        const { cardId } = params as {cardId: string};

        return getCard({ cardId });
    },
    [GET_CARD_REQUEST_SUCCEEDED]: () => [
        openCardModal(),
    ],
    [GET_CARD_REQUEST_FAILED]: (_, action) => [
        push(Routes.WORKFLOW),
        showErrorToast({ message: action.payload.response.data.detail }),
    ],
    [EDIT_CARD_REQUEST_FAILED]: () => [
        push(Routes.WORKFLOW),
        showErrorToast({ message: 'Something was wrong while saving your changes' }),
    ],
});
